import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import { pageFadeIn } from "../../../utils/animations";
import NavBar from "../../../Components/Navbar/NavBar";
import Sales from "./SalesGL";
import Reports from "./ReportsGL";
import About from "./AboutGL";
import gl_logo from "../../../Assets/General's Lechon Logo.jpg";

function GL() {
  const [selectedOption, setSelectedOption] = useState("Sales");

  const handleTabClick = (tab) => {
    setSelectedOption(tab);
  };

  const renderContent = () => {
    switch (selectedOption) {
      case "Sales":
        return <Sales content="Sales GL" color="orange" />;
      case "Reports":
        return <Reports content="Reports GL" />;
      case "About":
        return <About content="About GL" />;
      default:
        return <Sales content="Sales GL" color="orange" />;
    }
  };

  return (
    <Box h="100vh" bg="gray.50" overflow="hidden">
      <NavBar
        tabIndicatorColor="orange.500"
        logo={gl_logo}
        onTabClick={handleTabClick}
      />

      <Box
      w="100%"
      h="calc(100vh - 60px)"
      overflow="hidden"
      bgColor="white"
      bgImage={`linear-gradient(rgba(255,255,255,0.88), rgba(255,255,255,0.88)), url(${gl_logo})`}
      bgRepeat="no-repeat"
      bgSize="40% auto"
      bgPosition="right -80px"
      sx={{ animation: `${pageFadeIn} 0.55s ease both` }}
    >
        {renderContent()}
      </Box>
    </Box>
  );
}

export default GL;
